export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";